/**
 * Select a named labor rate, or the workshop default when empty (#2891).
 */

import { useId } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useLaborRates } from '@/hooks/useLaborRates';

interface LaborRateSelectProps {
  value: string | null;
  onChange: (laborRateId: string | null) => void;
  label: string;
  helperText?: string;
  emptyLabel: string;
  disabled?: boolean;
}

export function LaborRateSelect({
  value,
  onChange,
  label,
  helperText,
  emptyLabel,
  disabled,
}: LaborRateSelectProps) {
  const labelId = useId();
  const { data, isLoading } = useLaborRates({ isActive: true });
  const rates = data?.data ?? [];

  return (
    <FormControl fullWidth disabled={disabled || isLoading}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value ?? ''}
        onChange={(event) => {
          const next = event.target.value;
          onChange(next === '' ? null : next);
        }}
      >
        <MenuItem value="">{emptyLabel}</MenuItem>
        {rates.map((rate) => (
          <MenuItem key={rate.id} value={rate.id}>
            {rate.name}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
